import { Button } from "@heroui/react";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

interface ChatHeaderProps {
  onNewChat: () => void;
  onClose: () => void;
  isLoading?: boolean;
  language: "en" | "es";
  onLanguageChange: (language: "en" | "es") => void;
}

export function ChatHeader({ onNewChat, onClose, isLoading, language, onLanguageChange }: ChatHeaderProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-white rounded-t-2xl">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#215273] flex items-center justify-center flex-shrink-0">
          <span className="text-white font-semibold text-lg">C</span>
        </div>
        <div>
          <h1 className="font-semibold text-gray-900 text-sm">Cartago Trip Planner</h1>
          <p className="text-xs text-gray-500">
            {isLoading ? "Typing..." : "Online"}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <select
          value={language}
          onChange={(e) => onLanguageChange(e.target.value as "en" | "es")}
          className="px-2 py-1 text-xs border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#159193]"
        >
          <option value="es">ES</option>
          <option value="en">EN</option>
        </select>
        <Button
          size="sm"
          variant="light"
          isIconOnly
          onPress={onNewChat}
          className="text-[#159193] min-w-8 w-8 h-8"
          aria-label="New chat"
        >
          <AddIcon fontSize="small" />
        </Button>
        <Button
          size="sm"
          variant="light"
          isIconOnly
          onPress={onClose}
          className="text-gray-500 min-w-8 w-8 h-8"
          aria-label="Close chat"
        >
          <CloseIcon fontSize="small" />
        </Button>
      </div>
    </div>
  );
}
